import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#F8F9FA] dark:bg-[#121212] px-4 text-center transition-colors duration-300 overflow-hidden relative">
      {/* Background Decorative Elements */}
      <div className="absolute top-10 left-10 w-64 h-64 bg-[#2F80ED]/10 dark:bg-[#58A6FF]/10 rounded-full blur-3xl -z-10 animate-pulse"></div>
      <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#27AE60]/10 dark:bg-[#34D399]/10 rounded-full blur-3xl -z-10 animate-pulse delay-1000"></div>

      {/* Main Content */}
      <div className="relative mb-8 group">
        <h1 className="text-[120px] md:text-[200px] font-black text-[#2F80ED] dark:text-[#58A6FF] opacity-[0.08] select-none leading-none transition-transform duration-700 group-hover:scale-105">
          404
        </h1>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
             {/* 404 SVG Icon or Styled Text */}
             <div className="mb-4 p-4 bg-white dark:bg-[#1E1E1E] rounded-full shadow-2xl shadow-[#2F80ED]/20 dark:shadow-[#58A6FF]/20 transform transition-transform hover:rotate-12 duration-500">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-[#2F80ED] dark:text-[#58A6FF]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
             </div>
             <h2 className="text-3xl md:text-5xl font-bold text-[#333333] dark:text-[#E0E0E0] tracking-tight">
                Página no encontrada
             </h2>
        </div>
      </div>

      <p className="text-lg md:text-xl text-[#ADB5BD] dark:text-[#8B949E] max-w-lg mb-10 leading-relaxed">
        Lo sentimos, parece que la página que estás buscando se ha estacionado en otro lugar o no existe.
      </p>

      <div className="flex gap-4">
        <button
            onClick={() => navigate(-1)}
            className="px-8 py-3.5 rounded-xl bg-white dark:bg-[#1E1E1E] border border-[#ADB5BD]/30 text-[#333333] dark:text-[#E0E0E0] font-medium transition-all duration-300 hover:bg-[#F8F9FA] dark:hover:bg-[#2C2C2C] hover:shadow-lg focus:ring-2 focus:ring-[#ADB5BD]/50 outline-none"
        >
            Regresar
        </button>
        
        <button
            onClick={() => navigate('/')}
            className="px-8 py-3.5 rounded-xl bg-gradient-to-r from-[#2F80ED] to-[#27AE60] hover:from-[#2563EB] hover:to-[#229954] text-white font-bold transition-all duration-300 shadow-lg shadow-[#2F80ED]/30 hover:shadow-[#2F80ED]/40 hover:-translate-y-1 focus:ring-2 focus:ring-[#2F80ED]/50 outline-none"
        >
            Ir al Inicio
        </button>
      </div>
      
      <div className="mt-16 text-sm text-[#ADB5BD] dark:text-[#8B949E] opacity-60">
        Parqium &copy; {new Date().getFullYear()}
      </div>
    </div>
  );
}